import { render, staticRenderFns } from "./CharactersManeuvers.vue?vue&type=template&id=f0197d54&lang=pug&"
import script from "./CharactersManeuvers.vue?vue&type=script&lang=ts&"
export * from "./CharactersManeuvers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports